// extracted by mini-css-extract-plugin
export default {"WixIntrosTemplate":"mURiQW","wixIntrosTemplate":"mURiQW","WixIntrosTemplate__logo":"Y3bTGm","wixIntrosTemplateLogo":"Y3bTGm"};